<template>
  <main class="achievements-list">
    <section
      v-for="group in preparedAchievements"
      class="achievements-list__section"
      :key="group.title"
    >
      <h2 v-if="group.title" class="achievements-list__section-title">
        {{ group.title }}
      </h2>
      <ul class="achievements-list__group">
        <li
          v-for="item in group.items"
          class="achievements-list__item"
          :key="item.title"
        >
          <AchievementsListItem :achievement="item" />
        </li>
      </ul>
    </section>
  </main>
</template>

<script>
import AchievementsListItem from './AchievementsListItem.vue';

export default {
  name: 'AchievementsList',
  components: {
    AchievementsListItem,
  },
  props: {
    isOwner: Boolean,
    achievements: Array,
  },
  computed: {
    preparedAchievements() {
      if (this.isOwner) return this.achievements;

      const items = this.achievements
        .map((g) => g.items)
        .flat()
        .filter((i) => i.active);

      return [{ items }];
    },
  },
};
</script>
